import { LogLevel } from "@azure/msal-browser";
import { RedirectRequest } from '@azure/msal-browser';

export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1A_SSOSIGNIN",
    forgotPassword: "B2C_1A_PASSWORDRESET",
  },
  authorities: {
    signUpSignIn: {
      authority:
          "https://rsrgsgsgisb2c.b2clogin.com/rsrgsgsgisb2c.onmicrosoft.com/B2C_1A_SSOSIGNIN",
    },
    forgotPassword: {
      authority:
          "https://rsrgsgsgisb2c.b2clogin.com/rsrgsgsgisb2c.onmicrosoft.com/B2C_1A_PASSWORDRESET",
    },
  },
  authorityDomain: "rsrgsgsgisb2c.b2clogin.com",
};

export const redirectRequest: RedirectRequest = {
  scopes: ["openid", "profile"],
  authority: b2cPolicies.authorities.signUpSignIn.authority,
};

export const msalConfig = {
  auth: {
    clientId: "7d882a3b-f2dd-42fb-ae39-11b74bd06a74",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 10000,
    loadFrameTimeout: 10000,
    tokenRenewalOffsetSeconds: 300,
    allowRedirectInIframe: false,
    asyncPopups: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "https://rsrgsgsgisb2c.onmicrosoft.com/7d882a3b-f2dd-42fb-ae39-11b74bd06a74",
  ],
  authority: b2cPolicies.authorities.signUpSignIn.authority,
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ["openid", "profile"],
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  loginHint: "example@domain.net",
};